<template>
  <div>
    <Teleport
      v-if="afetrTitleActionSpaceMounted && magazine"
      to="#page-title-action-space"
    >
      <div class="d-flex align-items-center justify-content-end w-100">
        <BasicButton
          label="編集"
          variant="secondary"
          outlined
          icon="pi pi-pencil"
          @click="
            goto({
              name: 'UsersMagazinesEdit',
              params: {
                id: magazine.id,
              },
            })
          "
        />
      </div>
    </Teleport>

    <Card>
      <template #content>
        <MagazineShow v-if="magazine" :magazine="magazine" />
        <BackButton>
          <BasicButton
            v-if="magazine"
            label="編集"
            variant="secondary"
            outlined
            class="ms-5"
            icon="pi pi-pencil"
            @click="
              goto({
                name: 'UsersMagazinesEdit',
                params: {
                  id: magazine.id,
                },
              })
            "
          />
        </BackButton>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import { useMagazines, useRouterUtil } from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { UserPageActions } from "/@/vue/components/Layouts";
import { BackButton } from "/@/vue/components/Molecules";
import { Show as MagazineShow } from "/@/vue/components/Molecules/Magazines";
import Card from "primevue/card";

const afetrTitleActionSpaceMounted = inject("afetrTitleActionSpaceMounted");

const { currentRouteParams, goto } = useRouterUtil();
const id = computed(() => Number(currentRouteParams.value.id));

const { getUsersMagazine } = useMagazines();
const { data: magazine } = getUsersMagazine(id);
</script>

<style scoped></style>
